<template>
  <div class="content-main relative">
    <template v-if="openedPayment == ''">
      <NewPaymentModal
        @close="showNewPaymentModal = false"
        :value="true"
        v-if="showNewPaymentModal"
        @newPaymentProcessed="loadPayments"
        @singlePayment="newPaymentProcessed"
      ></NewPaymentModal>
      <div class="content">
        <!-- Infoauto unprocessed counter + filter -->
        <div
          class="search-bar"
          style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;"
        >
          <span v-if="infoautoUnprocessedCount > 0" class="unprocessed-badge">
            {{ infoautoUnprocessedCount }} sin procesar en Infoauto
          </span>
          <button
            class="btn-dark-button"
            :style="
              filters.infoautoProcessed === '0' ? 'background:#ca8a04' : ''
            "
            @click="toggleUnprocessedFilter"
          >
            {{
              filters.infoautoProcessed === "0"
                ? "Ver todos"
                : "Solo sin procesar"
            }}
          </button>
        </div>
        <!-- Search Bar -->
        <div class="search-bar">
          <div class="search-wrapper">
            <i class="mdi mdi-magnify search-icon"></i>
            <input
              type="text"
              v-model="filters.search"
              placeholder="Search payments by order number, customer, seller..."
              class="search-input"
            />
            <button
              v-if="filters.search"
              @click="filters.search = ''"
              class="clear-search"
            >
              <i class="mdi mdi-close"></i>
            </button>
          </div>
        </div>

        <div class="header relative">
          Payments
          <br />
          <br />
          <button
            class="btn-dark-button top-2 w-full md:w-auto"
            @click="showNewPaymentModal = true"
          >
            New Payment
          </button>
        </div>
        <div class="table">
          <!-- Desktop Table View (hidden on mobile) -->
          <div class="hidden md:block overflow-x-auto">
            <table class="default-table" v-if="!loading">
              <thead>
                <tr class="table100-head">
                  <th
                    v-for="headerItem in tableHeaders"
                    :key="headerItem.value"
                    @click="changeArrowDir(headerItem.value)"
                  >
                    {{ headerItem.displayText }}
                    <span v-if="filters.orderCol == headerItem.value">
                      <img
                        :src="
                          require(`@/assets/icons/${arrowDirection}-arrow.svg`)
                        "
                      />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="payment in payments"
                  :key="payment.id"
                  @click="open(payment.id)"
                  :class="{
                    selected: selectedPayment == payment.id,
                    'unprocessed-row': payment.infoautoProcessed == 0,
                    'refund-row': isRefund(payment)
                  }"
                >
                  <td>
                    <a @click="open(payment.id)">
                      {{ payment.orderNumber }}
                    </a>
                  </td>
                  <td>
                    {{ payment.date }}
                  </td>
                  <td style="max-width: 80px">
                    {{ payment.customerName }}
                  </td>
                  <td>
                    {{ payment.customerEmail }}
                  </td>
                  <td>
                    <template v-if="isRefund(payment)">
                      <span class="refund-amount">{{
                        refundMoney(payment.orderAmount)
                      }}</span>
                      <span class="refund-badge">↩ REFUND</span>
                    </template>
                    <template v-else>{{ payment.orderAmount }}</template>
                  </td>
                  <td>
                    {{ payment.seller }}
                  </td>
                  <td>
                    {{ payment.transactionTag }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile Card View (hidden on desktop) -->
          <div class="md:hidden space-y-3 p-2" v-if="!loading">
            <div
              v-for="payment in payments"
              :key="payment.id"
              @click="open(payment.id)"
              :class="[
                'border border-gray-300 rounded-lg p-4 shadow-sm cursor-pointer active:bg-gray-50',
                payment.infoautoProcessed == 0 ? 'bg-yellow-100' : 'bg-white',
                { 'refund-card': isRefund(payment) }
              ]"
            >
              <!-- Header: Order Number and Amount -->
              <div class="flex justify-between items-center mb-3 pb-3 border-b">
                <div>
                  <div class="text-xs text-gray-500 uppercase">Order</div>
                  <div class="font-bold text-lg text-blue-600">
                    {{ payment.orderNumber }}
                  </div>
                </div>
                <div class="text-right">
                  <div class="text-xs text-gray-500 uppercase">Amount</div>
                  <div v-if="isRefund(payment)" class="text-lg">
                    <span class="refund-amount">{{
                      refundMoney(payment.orderAmount)
                    }}</span>
                    <div><span class="refund-badge">↩ REFUND</span></div>
                  </div>
                  <div v-else class="text-lg font-bold text-green-600">
                    ${{ payment.orderAmount }}
                  </div>
                </div>
              </div>

              <!-- Customer Info -->
              <div class="mb-3">
                <div class="text-xs text-gray-500 uppercase mb-1">Customer</div>
                <div class="text-sm font-medium text-gray-800">
                  {{ payment.customerName }}
                </div>
                <div v-if="payment.customerEmail" class="text-sm text-gray-600">
                  {{ payment.customerEmail }}
                </div>
              </div>

              <!-- Payment Details Grid -->
              <div class="grid grid-cols-2 gap-3 mb-3">
                <div>
                  <div class="text-xs text-gray-500 uppercase">Date</div>
                  <div class="text-sm text-gray-800">{{ payment.date }}</div>
                </div>
                <div>
                  <div class="text-xs text-gray-500 uppercase">Seller</div>
                  <div class="text-sm text-gray-800">
                    {{ payment.seller || "N/A" }}
                  </div>
                </div>
              </div>

              <!-- Transaction Tag -->
              <div
                v-if="payment.transactionTag"
                class="bg-gray-100 p-2 rounded"
              >
                <div class="text-xs text-gray-500 uppercase mb-1">
                  Transaction ID
                </div>
                <div class="text-xs text-gray-700 break-all">
                  {{ payment.transactionTag }}
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            Loading...
          </div>
        </div>
        <div class="footer">
          <div class="totals">
            showing {{ filters.limitPerPage * (filters.page - 1) }} to
            {{ toQuantity() }} from {{ totalItems }} results
          </div>
          <div class="pages">
            <select
              v-model="paymentsByPage"
              @change="
                (filters.limitPerPage = paymentsByPage), (filters.page = 1)
              "
              class="md:w-auto w-16 text-sm"
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            <span class="hidden md:inline">Per Page</span>
            <span class="md:hidden text-xs">/ page</span>
          </div>
          <div class="pages">
            <div>
              <a
                :class="{ disabled: filters.page == 0 }"
                class="page-link"
                @click="previous()"
                >Prev</a
              >
            </div>
            <div class="hidden md:block">Page {{ filters.page }}</div>
            <div class="md:hidden">{{ filters.page }}</div>
            <div>
              <a
                :class="{
                  disabled: totalPages > filters.page
                }"
                class="page-link"
                @click="next()"
                >Next</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="flex justify-center items-center w-full pt-10">
      <button
        class="btn-dark-button absolute right-2 top-2"
        @click="openedPayment = ''"
      >
        Close (Q)
      </button>
      <PaymentModal
        @closedPayment="openedPayment = ''"
        @transactionUpdated="loadPayments"
        @openPayment="open"
        :paymentId="openedPayment"
        v-model="showPaymentModal"
      />
    </div>
  </div>
</template>

<script>
import { getPosPayments } from "@/api/store/PaymentsService.js";
import { createQueryString } from "@/api/store/OrdersService.js";
import PaymentModal from "@/components/payments/PaymentModal.vue";
import NewPaymentModal from "@/components/payments/NewPaymentModal";
export default {
  name: "PosPaymentsPage",
  components: { PaymentModal, NewPaymentModal },
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      tableHeaders: [
        {
          displayText: "Order Number",
          value: "orderNumber"
        },
        {
          displayText: "Date",
          value: "date"
        },
        {
          displayText: "Customer Name",
          value: "customerNmae"
        },
        {
          displayText: "Email",
          value: "customerEmail"
        },
        {
          displayText: "Total",
          value: "orderAmount"
        },
        {
          displayText: "Seller",
          value: "seller"
        },
        {
          displayText: "Transaction Tag",
          value: "transactionTag"
        }
      ],
      filters: {
        page: 1,
        limitPerPage: 100,
        orderCol: "date",
        orderDir: "desc",
        search: "",
        infoautoProcessed: ""
      },
      paymentsByPage: 100,
      payments: [],
      totalItems: 0,
      totalPages: 0,
      infoautoUnprocessedCount: 0,
      loading: true,
      selectedPayment: null,
      openedPayment: "",
      showPaymentModal: false,
      showNewPaymentModal: false,
      apiCallId: null
    };
  },
  watch: {
    openedPayment() {
      if (!this.loading) {
        const query = {
          ...this.$route.query,
          openedPayment: this.openedPayment
        };
        this.$router.replace({ query }).catch(() => {});
      }
    },
    filters: {
      deep: true,
      handler() {
        if (!this.loading) {
          const query = {
            ...this.$route.query,
            search: createQueryString(this.filters)
          };
          this.$router.replace({ query }).catch(() => {});
          this.loadPayments();
        }
      }
    }
  },
  computed: {
    arrowDirection() {
      return this.filters.orderDir == "desc" ? "down" : "up";
    }
  },
  mounted() {
    let search = new URLSearchParams(this.$route.query.search);
    if (search) {
      for (let p of search) {
        this.filters[p[0]] = p[1];
      }
    }
    let openedPayment = this.$route.query.openedPayment;
    if (openedPayment && openedPayment != "") {
      console.log(openedPayment);
      this.open(openedPayment);
    }
    this.loading = false;
    this.loadPayments();
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    async loadPayments() {
      this.apiCallId = new Date();
      let apiCallIdCurrent = this.apiCallId;
      const res = await getPosPayments(this.filters).catch(() => {
        this.$toast.open({
          message: "Error getting customers",
          type: "Error",
          position: "top-right"
        });
      });
      if (apiCallIdCurrent !== this.apiCallId) {
        console.warn("new request in process");
        return;
      }
      if (res.transactions) {
        this.payments = res.transactions;
        this.totalItems = res.totalItems;
        this.totalPages = res.totalPages;
        this.infoautoUnprocessedCount = res.infoautoUnprocessedCount || 0;
      }
      this.loading = false;
    },
    previous() {
      if (this.filters.page > 1) {
        this.filters.page = this.filters.page - 1;
      }
    },
    next() {
      if (this.totalItems >= this.filters.limitPerPage * this.filters.page) {
        this.filters.page = this.filters.page + 1;
      }
    },
    toQuantity() {
      if (this.qtyPerPage * this.page > this.totalItems) {
        return this.payments.length;
      } else {
        return (
          this.filters.limitPerPage * (this.filters.page - 1) +
          this.payments.length
        );
      }
    },
    changeArrowDir(headerValue) {
      this.filters.page = 1;
      if (headerValue == this.filters.orderCol) {
        this.filters.orderDir =
          this.filters.orderDir == "desc" ? "asc" : "desc";
      } else {
        this.filters.orderCol = headerValue;
        this.filters.orderDir = "desc";
      }
    },
    // Reembolsos: filas negativas (ver Stripex::admin_refund en usa-web-api)
    isRefund(payment) {
      return Number(payment.orderAmount) < 0;
    },
    refundMoney(value) {
      return `−$${Math.abs(Number(value)).toFixed(2)}`;
    },
    open(paymentID) {
      this.openedPayment = paymentID;
      this.showPaymentModal = true;
    },
    newPaymentProcessed(id) {
      this.showNewPaymentModal = false;
      this.open(String(id));
      this.loadPayments();
    },
    toggleUnprocessedFilter() {
      this.filters.infoautoProcessed =
        this.filters.infoautoProcessed === "0" ? "" : "0";
      this.filters.page = 1;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  display: flex;
  flex-direction: column;
  height: 100%;

  .search-bar {
    background: white;
    padding: 15px;
    border-bottom: 1px solid #e5e7eb;

    @media (max-width: 768px) {
      padding: 10px;
    }

    .search-wrapper {
      position: relative;
      max-width: 600px;

      @media (max-width: 768px) {
        max-width: 100%;
      }

      .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #6b7280;
        font-size: 20px;
        pointer-events: none;
      }

      .search-input {
        width: 100%;
        padding: 10px 40px 10px 42px;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        font-size: 15px;
        transition: border-color 0.2s, box-shadow 0.2s;

        @media (max-width: 768px) {
          font-size: 16px; /* Prevent zoom on iOS */
          padding: 12px 40px 12px 42px;
        }

        &:focus {
          outline: none;
          border-color: $link-color-1;
          box-shadow: 0 0 0 3px rgba(18, 110, 106, 0.1);
        }

        &::placeholder {
          color: #9ca3af;
        }
      }

      .clear-search {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        padding: 4px;
        cursor: pointer;
        color: #6b7280;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background-color 0.2s;

        &:hover {
          background-color: #f3f4f6;
        }

        i {
          font-size: 18px;
        }
      }
    }
  }

  .unprocessed-badge {
    background: #fef08a;
    border: 1px solid #ca8a04;
    color: #92400e;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 0.85rem;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
  }

  > .content {
    background-color: white;
    padding: 5px;

    @media (max-width: 768px) {
      padding: 0;
    }

    > .header {
      padding: 20px 15px;

      @media (max-width: 768px) {
        height: auto;
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 600;
      }
    }

    > .table {
      padding: 0 15px;

      @media (max-width: 768px) {
        padding: 0;
      }
    }

    .unprocessed-row {
      background-color: #fef9c3 !important;
    }

    // Reembolso: fondo rojo claro y borde rojo. Si además está pendiente en
    // Infoauto conserva el amarillo; el borde y la etiqueta marcan el refund.
    .refund-row {
      background-color: #fee2e2 !important;
      box-shadow: inset 5px 0 0 #dc2626;

      &.unprocessed-row {
        background-color: #fef9c3 !important;
      }
    }

    > .footer {
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 1rem;
        padding: 15px 10px;
      }

      .totals {
        @media (max-width: 768px) {
          text-align: center;
          font-size: 0.875rem;
        }
      }

      .pages {
        display: flex;
        gap: 10px;
        align-items: center;

        @media (max-width: 768px) {
          justify-content: center;
          width: 100%;
          gap: 0.5rem;
          font-size: 0.875rem;
        }

        .page-link {
          cursor: pointer;
          color: $link-color-1;
          text-decoration: none;
          padding: 0.5rem 0.75rem;
          border-radius: 4px;
          transition: background-color 0.2s;

          @media (max-width: 768px) {
            min-width: 44px;
            min-height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f0f0f0;
          }

          &:hover {
            background-color: #e9ecef;
          }

          &.disabled {
            cursor: not-allowed;
            color: #6c757d;
            opacity: 0.5;
          }
        }

        select {
          @media (max-width: 768px) {
            min-height: 44px;
            padding: 0.5rem;
          }
        }
      }
    }
  }
}

/* Reembolsos (filas negativas) */
.refund-amount {
  color: #b91c1c;
  font-weight: 800;
  white-space: nowrap;
}
.refund-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 9999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;
  vertical-align: middle;
}
.refund-card {
  border-color: #fca5a5 !important;
  box-shadow: inset 5px 0 0 #dc2626;
}
.refund-card.bg-white {
  background-color: #fef2f2 !important;
}
</style>
